// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__2pBYc","hand":"Spinner_hand__3H8UE","rotate":"Spinner_rotate__1So6g","invisible":"Spinner_invisible__S7JYF"};